import {initWebComponent} from "@/helpers/web-component-helper";
import {hideLayerInfoForm} from "@/helpers/layer/info/layer-info-helper";

const template = document.createElement('template');
template.innerHTML = `
<button class="btn btn-sm btn-outline-secondary text-transform-none btn-block popper-header" type="button">
    <span class="fa fa-file-import"></span> Data importeren
    <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
         Importeer een service of bestand
    <div class="arrow" data-popper-arrow=""></div>
  </div>
</button>`;

export class LayerMenuActiveAddDatasetComponent extends HTMLElement{
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            const element = document.querySelectorAll('bookmark-data-set')[0]
            const classList = [...element.classList]

            hideLayerInfoForm()

            if(classList.includes('d-none')) {
                element.classList.remove('d-none')
                element.parentNode.classList.remove('d-none')
            }
        })
    }
}
